/* global s */
'use strict';

function tracking(EVENTS, MODALS) {
	if (typeof s === 'undefined') {
		return;
	}

	var PubSub = require('pubsub-js');

	s.channel = 'brand';						// site section
	s.prop2 = 'social asset generator 2.0';		// site name
	s.prop10 = 'brand';							// page division

	PubSub.subscribe(EVENTS.PAGE_ENTER, pageTracking);				// tracking switching pages
	PubSub.subscribe(EVENTS.TREATMENT_TRACKING, treatmentTracking);	// tracking switching pages
	PubSub.subscribe(EVENTS.MODAL_OPEN, errorTracking);				// tracking error messages
	PubSub.subscribe(EVENTS.MODAL_CLOSE_TRACKING, modaleClosing);	// tracking closing modales
	PubSub.subscribe(EVENTS.FACEBOOK_TRACKING, facebookTracking);	// tracking facebook sharing

	var trackVars1 = 'channel,prop2,prop5,prop10,prop14,prop15,prop50,eVar4,pageName';
	var trackVars2 = 'channel,prop2,prop3,prop5,prop10,prop14,prop15,prop50,eVar4,pageName';
	var errorWindowOpened = 0;

	function pageTracking(msg, data) {
		if(typeof s.pageName !== 'undefined') {
			s.prop5 = s.pageName;
		}

		s.prop14 = window.NIKE.country || 'gb';		// country code
		s.prop15 = window.NIKE.lang || 'en';		// language code

		s.eVar4 = window.NIKE.isLoggedIn ? 'logged in' : 'not logged in';
		s.prop50 = window.NIKE.isLoggedIn ? window.NIKE.uuid : '';

		switch(window.NIKE.currentPageId) {
			case 'index':
				s.pageName = 'social asset generator>landing';
				s.linkTrackVars = trackVars1;
				s.t();
				break;
			case 'treatment':
				s.pageName = 'social asset generator>pack selection';
				s.linkTrackVars = trackVars1;
				s.t();
				break;
			case 'opened':
				s.pageName = 'social asset generator>photo edit';
				s.linkTrackVars = trackVars1;
				s.t();
				break;
			case 'share':
				s.pageName = 'social asset generator>share';
				s.linkTrackVars = trackVars1;
				s.t();
				break;
		}
	}

	function treatmentTracking(msg, data) {
		s.prop3 = data.name;
		s.linkTrackVars = trackVars2;
		s.tl(data.obj, 'o', 'page activity click');
	}

	function errorTracking(msg, data) {
		s.prop5 = s.pageName;
		switch(data) {
			case MODALS.ERROR_SIZE:
			case MODALS.ERROR_WEIGHT:
			case MODALS.ERROR_TYPE:
			case MODALS.ERROR_TIMEOUT:
				s.pageName = 'social asset generator>photo upload failed';
				errorWindowOpened = 1;
				break;
			case MODALS.ERROR_PROCESS:
				s.pageName = 'social asset generator>photo edit failed';
				errorWindowOpened = 1;
				break;
		}
		s.linkTrackVars = trackVars1;
		s.t();
	}

	function modaleClosing(msg, data) {
		if(errorWindowOpened) {
			errorWindowOpened = 0;
			s.prop5 = s.pageName;
			pageTracking(msg, data);
		}
	}

	function facebookTracking(msg, data) {
		s.prop3 = 'share:facebook';
		s.linkTrackVars = trackVars2;
		s.events = 'event43';
		s.linkTrackEvents = 'event43';
		s.tl(data, 'o', 'social interaction');
	}

	var downloadButton = document.getElementById('button-download');
	downloadButton.onclick = function() {
		s.prop3 = 'download';
		s.linkTrackVars = trackVars2;
		s.tl(this, 'o', 'page activity click');
	};
}

module.exports = tracking;
